import MsiBravo15 from "../assets/msi/MSIBravo15.jpg";

const msiProducts = [
  {
    id: 1,
    name: "MSI Bravo 15",
    image: MsiBravo15,
    specs: [
      "AMD Ryzen 7 5800H processor",
      "Windows 11",
      "16GB RAM",
      "512GB SSD Nvme 4.0",
      "AMD Radeon RX6500 M 4GB GPU",
      "15.6 144Hz FH Display",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in MSI Bravo 15",
  },
];

export default msiProducts;